import React, { useEffect, useState } from "react";
import classes from "./AdBanner.module.scss";
import CustomImage from "../../CustomImage";
import { isFrappeOrJotFormClass } from "../../../utils/helpers";
import useIsMobile from "../../../hooks/useIsMobile";

const AdBanner = ({ bannerData }: any) => {
  const isTab = useIsMobile(1150);
  const isMobile = useIsMobile(768);
  const bannerImageData = !isTab ? bannerData?.priorityImage : bannerData?.priorityImageMobile;
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);

  useEffect(() => {
    setAspectRatio(null);
    const url = bannerImageData?.url;
    if (isTab || !url) return;

    const img = new window.Image();
    const onLoad = () => {
      if (img.naturalWidth && img.naturalHeight) {
        setAspectRatio(img.naturalWidth / img.naturalHeight);
      }
    };
    img.addEventListener("load", onLoad);
    img.src = url;
    return () => img.removeEventListener("load", onLoad);
  }, [bannerImageData?.url, isTab]);

  const ctaBtnClickHandler = (link: string) => () => {
    window.open(link, "_blank");
  };

  const imageClickHandler = (url: string) => () => {
    window.open(url ?? "", "_blank");
  };

  const Tag = ({ tag, index }: any) => {
    return (
      <div className={`${classes["tag-container"]} ${classes[`tag-container-${index + 1}`]}`}>
        <div className={classes["icon-container"]}>
          <CustomImage src={tag?.icon?.url ?? ""} width={26} height={26} alt={tag?.icon?.name ?? ""} />
        </div>
        <div className={classes["text-holder"]}>
          <h4>{tag?.title}</h4>
          <p>{tag?.description}</p>
        </div>
        <div className={classes.description} dangerouslySetInnerHTML={{ __html: tag?.trailingText }}></div>
      </div>
    );
  };

  return (
    <div className={classes["banner-section"]}>
      <div className={classes["banner-container"]}>
        {bannerImageData?.url ? (
          <div className={classes["image-wrapper"]} onClick={imageClickHandler(bannerData?.priorityImageUrl ?? "")}>
            <div
              className={classes["priority-image-container"]}
              style={!isTab && aspectRatio ? { aspectRatio: String(aspectRatio), height: "auto" } : undefined}
            >
              <CustomImage
                src={(bannerImageData?.url ?? "/images/man_with_foldedhands.png") as string}
                alt={bannerData?.title ?? "banner-image"}
                layout="fill"
                objectFit={isTab ? "fill" : "contain"}
                className={classes["priority-image"]}
                priority
                isLazyLoad={false}
              />
            </div>
          </div>
        ) : (
          <>
            <picture className={classes["bg-picture"]}>
              <source media="(max-width: 767px)" srcSet={isMobile ? bannerData?.bgImageMobile?.url : bannerData?.bgImage?.url} />
              <img
                src={isMobile ? bannerData?.bgImageMobile?.url : bannerData?.bgImage?.url}
                loading="eager"
                fetchPriority="high"
                decoding="async"
                width={"100%"}
                height={"100%"}
              />
            </picture>

            <div className={classes["content-container"]}>
              <h2 className={classes["title"]}>{bannerData?.title}</h2>
              <p className={classes["description"]}>{bannerData?.description}</p>
              <button
                className={`${classes["enquire-btn"]} ${!bannerData?.button?.link && bannerData?.button?.formId && isFrappeOrJotFormClass(bannerData?.button?.formId)}`}
                onClick={bannerData?.button?.link ? ctaBtnClickHandler(bannerData?.button?.link) : undefined}
              >
                {bannerData?.button?.title}
              </button>
            </div>
            {!isTab && !isMobile && (
              <div className={classes["tags-container"]}>
                {bannerData?.featureTag?.map((tag: any, index: number) => (
                  <Tag tag={tag} index={index} />
                ))}
              </div>
            )}

            {isTab && !isMobile && (
              <div className={classes["tags-container-tab"]}>
                {bannerData?.featureTag?.map((tag: any, index: number) => (
                  <Tag tag={tag} index={index} />
                ))}
              </div>
            )}

            {isMobile && (
              <div className={classes["tags-container-mobile"]}>
                <div className={classes["tag-row-1"]}>
                  {bannerData?.featureTag?.[0] && <Tag tag={bannerData?.featureTag?.[0]} index={0} />}

                  {bannerData?.featureTag?.[1] && <Tag tag={bannerData?.featureTag?.[1]} index={1} />}
                </div>
                <div className={classes["tag-row-2"]}>{bannerData?.featureTag?.[2] && <Tag tag={bannerData?.featureTag?.[2]} index={2} />}</div>
                <div className={classes["tag-row-3"]}>
                  {bannerData?.featureTag?.[3] && <Tag tag={bannerData?.featureTag?.[3]} index={3} />}

                  {bannerData?.featureTag?.[4] && <Tag tag={bannerData?.featureTag?.[4]} index={4} />}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdBanner;
